import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Supplier } from 'src/app/model/supplier';


@Component({
  selector: 'app-delete-supplier-dialog',
  templateUrl: './delete-supplier-dialog.component.html',
  styleUrl: './delete-supplier-dialog.component.scss'
})
export class DeleteSupplierDialogComponent {
  /** Row definitions to show supplier information */
  public items: any[] = [
    {
      title: "Supplier ID",
      name: "merchantID",
    },
    {
      title: "First Name",
      name: "firstName",
    },
    {
      title: "Last Name",
      name: "lastName",
    },
    {
      title: "Email Address",
      name: "emailAddress",
    },
    {
      title: "Phone Number",
      name: "phoneNumber",
      format: "phone",
    },
    {
      title: "Street Address",
      name: "streetAddress",
    },
    {
      title: "City",
      name: "city",
    },
    {
      title: "State Abbreviation",
      name: "stateAbbr",
    },
    {
      title: "Postal Code",
      name: "postalCode",
    },
    {
      title: "Status",
      name: "status",
    },
    {
      title: "Mac Truck Signup ID",
      name: "macTruckSignupID",
    },
    {
      title: "Merchant Name",
      name: "merchantName",
    },
    {
      title: "Division",
      name: "division",
    },
    {
      title: "Region",
      name: "region",
    },
    {
      title: "District",
      name: "district",
    },
    {
      title: "Owner Merchant ID",
      name: "ownerMerchantID",
    },
    {
      title: "Owner Email",
      name: "ownerEmail",
    },
    {
      title: "Owner Phone",
      name: "ownerPhone",
    },
    {
      title: "Status Date",
      name: "statusDate",
    },
  ];

  /** The supplier this class is verifying deletion on */
  public supplier: any;

  /**
   * Default constructor initializes the component with a dialog ref
   * @param dialogRef
   */
  constructor(
    public dialogRef: MatDialogRef<DeleteSupplierDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {supplier: Supplier},
  ) {
    this.supplier = this.data?.supplier;
  }

  /**
   * Cancel the deletion and close the dialog
   */
  public cancel() {
    this.dialogRef.close(false);
  }

  /**
   * Approve the deletion and close the dialog
   */
  public remove() {
    this.dialogRef.close(true);
  }
}
